import React, { useState } from "react";
import "./Header.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMagnifyingGlass,
  faInfoCircle,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { faMessage } from "@fortawesome/free-regular-svg-icons";
import DropdownMenu from "./DropdownMenu";
import { Link, useNavigate } from "react-router-dom";

function Header() {
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchTerm.trim())}`);
      setSearchTerm("");
    }
  };

  return (
    <div className="header">
      <Link className="links link__header" to="/">
        <img className="header__logo" src="/images/isaks-bilar-logo.png" alt="Isaks Bilar Logo" />
      </Link>
      <Link className="links link__header" to="/">
        <div className="logo__name">
          <h1>Isaks Bilar</h1>
        </div>
      </Link>
      <div className="category__bar">
        <DropdownMenu />
      </div>

      <form className="header__search" onSubmit={handleSearch}>
        <input
          className="header__searchInput"
          type="text"
          placeholder="Sök produkt ..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <button type="submit" className="header__searchButton">
          <FontAwesomeIcon
            className="header__searchIcon"
            icon={faMagnifyingGlass}
          />
        </button>
      </form>

      <div className="header__nav">
        <Link className="links link_header" to="/customer">
          <div className="header__option option__hoverGray">
            <span className="header__optionLine ">
              Kundservice{' '}
              <span>
                <FontAwesomeIcon className="cservice__icon" icon={faMessage} />
              </span>
            </span>
          </div>
        </Link>

        <Link className="links link__header" to="/about">
          <div className="header__option option__hoverGray">
            <span className="header__optionLine">
              Om Oss{' '}
              <span>
                <FontAwesomeIcon className="info__icon" icon={faInfoCircle} />
              </span>
            </span>
          </div>
        </Link>

        <Link className="links link__header" to="/contact">
          <div className="header__option option__hoverGray">
            <span className="header__optionLine">
              Kontakt{' '}
              <span>
                <FontAwesomeIcon className="phone__icon" icon={faPhone} />
              </span>
            </span>
          </div>
        </Link>
      </div>
    </div>
  )
}

export default Header;
